import axios from "axios";

export default function getListing({ page, length, name, status }) {
  const start = page * length;
  const promise = new Promise((resolve, reject) =>
    axios
      .get("/account/system-admin/api/v1/admin-role", {
        params: {
          start,
          length,
          name,
          status,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );

  return promise;
}
